import { useState, useEffect } from 'react'
import Store from '../../Store/Store';
import Request from '../../Request/Request';
import getData from './../getData';
import Buttons from './Buttons';
import Row from './Row';
import UploadFile from '../../Admin/UploadFile'
import Gallery from './Gallery'
import { ContentRow } from "../../Page/Content"

// 	<ContentRow row={ rows[ rows.findIndex( e => e.id === rowId ) ] } index={ 1 } /> 

function PreviewRow( props ) {

	const data = props.data

	const cruiseId = '14789edc-2b0a-4fc2-9b53-a98262a2ee0e'
	const [ categories, setCategories ] = useState( Store.get( 'categories' ) || {} )
	const [ cuiseExample, setCruiseExample ] = useState( Store.get( 'cuise-example-' + cruiseId ) || {} )
	//const [ cruises, setCruises ] = useState( Store.get( 'cruises' ) || {} )

	useEffect(() => {
		if ( data.hasOwnProperty( 'category_id' ) ) {
			Request.get( 'categories', result => { 
				Store.set( 'categories', result.data )
				setCategories( result.data ) 
			} )
		}
		if ( !cuiseExample.hasOwnProperty( 'id' ) ) {
			Request.get( 'cruise/' + cruiseId, result => { 
				Store.set( 'cuise-example-' + cruiseId, result.data )
				setCategories( result.data ) 
			} )
		}
	}, [] )

	return <ContentRow row={ data } categories={ categories } cruise={ cuiseExample } index={ 1 } /> 

}



export default function Update( props ) {

	const [ data, setData ] = useState( {} )
	const [ original, setOriginal ] = useState( {} )
	const [ tmp, setTmp ] = useState( 1 )

	const [ preview, setPreview ] = useState( false )

	const table = props.table
	const rowId = props.rowId

	useEffect(() => {
		if ( rowId === true ) {
			setOriginal( {} ) // rowId === true => new
			setData( props.insertDefaults ? props.insertDefaults : {} ) // default values
		} else {
			setData( Store.get( 'row-' + table + '-' + rowId ) || {} )
			const path = 'row/' + table + '/' + rowId
			getData( path, setData, d => { 
				setOriginal( JSON.parse( JSON.stringify( d ) ) ) 
				Store.set( 'row-' + table + '-' + rowId, d )
			} )
		}
	}, [ table, rowId ] ) ;

	useEffect(() => {
		window.scrollTo( { top:0, left:0 } )
	}, [] )

	const immutables = [ 'id', 'created', 'modified', 'ordinal', 'token', 'token_created', 'token_expires' ]

	if ( !data || data === {} ) return false

	return (
		<div style={{ position:'relative' }} >

			{ props.showPreview && table === 'rows' && <>
				<div 
					className="material-symbols-outlined" 
					onClick={ e => setPreview( !preview ) }
					style={{ 
						position:'absolute', top:-46, left:580, 
						fontSize:30, cursor:'pointer', 
						opacity:preview ? 1 : 0.5, 
					}} 
				>
				{ preview ? 'preview' : 'preview_off' }
				</div>
				{ preview && 
					<PreviewRow data={ data } /> 
				}
			</> }

			{ !preview && 
			<table style={{ fontSize:13, marginLeft:20 }} ><tbody>

			{ props.structure.hasOwnProperty( table ) && props.structure[ table ].map( ( c, i ) => { 
				if ( rowId === true && immutables.includes( c.column_name ) ) return false
				return <>
					<Row { ...{ c, data, setData, immutables } } />
					{ c.column_name === 'gallery' && data[ c.column_name ] === 't' && 
						<Gallery {...{ table, data, tmp, setTmp }} />
					}
				</> 
			} ) }

			<tr><td colSpan={ 2 } style={{ border:'none', padding:0 }} >
				<Buttons 
					{ ...{ data, original, immutables, table, rowId } }
					setRowId={ props.setRowId } 
					rows={ props.rows }
					setRows={ props.setRows }
				/>
			</td></tr>

			</tbody></table>
			}

			<div style={{ padding:15 }} />

		</div>
	)
}
